import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/index';
import qs from 'qs';
Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    linkActiveClass: 'is-active',
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash,
                behavior: 'smooth',
            };
        }
        return { x: 0, y: 0 };
    },
    stringifyQuery: (query) => {
        const result = qs.stringify(query, { format: 'RFC1738' });
        return result ? '?' + result : '';
    },
    routes: [
        {
            path: '/',
            name: 'home',
            meta: { denyVicensUsers: true },
            component: () =>
                import(/* webpackChunkName: "login" */ './views/Home.vue'),
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: () =>
                import(/* webpackChunkName: "Demo" */ './views/Privacy.vue'),
        },
        {
            path: '/register',
            name: 'register',
            meta: { requiresAnonymous: true },
            component: () =>
                import(
                    /* webpackChunkName: "loginlocal" */ './views/Register.vue'
                ),
        },
        {
            path: '/login/local',
            name: 'loginlocal',
            props: (route) => route.query,
            meta: { requiresAnonymous: true },
            component: () =>
                import(
                    /* webpackChunkName: "loginlocal" */ './views/LoginLocal.vue'
                ),
        },
        {
            path: '/login/auth_callback',
            name: 'login',
            props: (route) => route.query,
            component: () =>
                import(/* webpackChunkName: "login" */ './views/Login.vue'),
        },
        {
            path: '/login/auth_callback_microsoft',
            name: 'login_microsoft',
            component: () =>
                import(
                    /* webpackChunkName: "login_microsoft" */
                    './views/LoginMicrosoft.vue'
                ),
        },
        {
            path: '/dashboard',

            meta: { requiresAuth: true, denyVicensUsers: true },
            components: {
                default: () =>
                    import(
                        /* webpackChunkName: "dashboard" */ './views/Dashboard.vue'
                    ),
            },
            children: [
                {
                    path: '',
                    name: 'dashboard',
                    components: {
                        default: () =>
                            import('./components/DashboardProjects.vue'),
                    },
                },
                {
                    path: '/school',
                    name: 'school',
                    component: () =>
                        import(
                            /* webpackChunkName: "profile" */
                            './components/DashboardSchool.vue'
                        ),
                },
                {
                    path: 'sessions',
                    name: 'dashboard-sessions',
                    component: () =>
                        import(
                            /* webpackChunkName: "sessions" */
                            './components/DashboardSessions.vue'
                        ),
                },

                {
                    path: '/school/groups',
                    name: 'groups',
                    component: () =>
                        import(
                            /* webpackChunkName: "groups" */
                            './components/UserGroupsTable.vue'
                        ),
                },

                {
                    path: '/communities',
                    name: 'communities',
                    props: { default: true },
                    component: () =>
                        import(
                            /* webpackChunkName: "communities" */
                            './components/DashboardCommunitiesMine.vue'
                        ),
                },
                {
                    path: '/import',
                    name: 'import',
                    props: { default: true },
                    component: () =>
                        import(
                            /* webpackChunkName: "import" */
                            './components/DashboardImport.vue'
                        ),
                },
                /*  {
          path: "/communities/explorer",
          name: "communities-explorer",
          props: { default: true },
          component: () =>
            import(
              "./components/DashboardCommunitiesExplorer.vue"
            ),
        },*/
                {
                    name: 'dashboard-folder',
                    path: 'folder/:folder([a-fA-F0-9]{24})',
                    props: { default: true },
                    component: () =>
                        import(
                            /* webpackChunkName: "folder" */
                            './components/DashboardFolderContent.vue'
                        ),
                },
            ],
        },
        {
            path: '/my-comunities',
            name: 'my-comunities',
            component: () =>
                import(/* webpackChunkName: "my-comunities" */ './views/MyCommunities.vue'),
        },
        {
            path: '/explore',
            name: 'explorer',
            components: {
                default: () =>
                    import(
                        /* webpackChunkName: "explorer" */ './views/Explorer.vue'
                    ),
            },
        },
        {
            path: '/play',
            name: 'play',
            meta: { requiresAuth: true, layout: 'project' },
            components: {
                default: () => import('./views/Play.vue'),
            },
            /*children: [
                                {
                                  path: "",
                                  components: {
                                    session: () => import("./components/SessionJoinModal.vue"),
                                    ranking: () => import("./components/SessionRanking.vue"),
                                  },
                                },
                              ],*/
        },
        {
            path: '/creation',
            name: 'creation',
            meta: { requiresAuth: true },
            components: {
                default: () =>
                    import(
                        /* webpackChunkName: "creation" */ './views/Creation.vue'
                    ),
            },
        },
        {
            path: '/project/:projectId([a-fA-F0-9]{24})',
            name: 'project',
            props: { default: true },
            meta: { layout: 'project' },
            components: {
                default: () =>
                    import(
                        /* webpackChunkName: "project" */ './views/Project.vue'
                    ),
            },
            children: [
                {
                    path: ':objectId([a-fA-F0-9]{24})',
                    name: 'object-detail',
                    meta: { layout: 'project' },
                    props: { default: true },
                    components: {
                        default: () =>
                            import(
                                /* webpackChunkName: "object-detail" */
                                './components/ProjectContentModalView.vue'
                            ),
                    },
                },
                {
                    path: 'sessions',
                    meta: { layout: 'project' },
                    name: 'project-sessions',
                    components: {
                        sessions: () =>
                            import('./components/ProjectSessions.vue'),
                    },
                },
                {
                    meta: { layout: 'project' },
                    path: 'session-resume',
                    name: 'session-resume',
                    components: {
                        default: () => import('./components/SessionResume.vue'),
                    },
                },
            ],
        },
        {
            path: '/embed/project/:projectId([a-fA-F0-9]{24})',
            name: 'embed-project',
            props: { default: true },
            meta: { layout: 'project', hideLogin: true, embed: true },
            components: {
                default: () =>
                    import(
                        /* webpackChunkName: "project-embed" */
                        './views/Project.vue'
                    ),
            },
            children: [
                {
                    path: ':objectId([a-fA-F0-9]{24})',
                    name: 'embed-object-detail',
                    meta: { layout: 'project', embed: true },
                    props: { default: true },
                    components: {
                        default: () =>
                            import(
                                /* webpackChunkName: "object-detail" */
                                './components/ProjectContentModalView.vue'
                            ),
                    },
                },
            ],
        },
        {
            path: '/profile',
            props: { default: true },
            meta: { requiresAuth: true, denyVicensUsers: true },
            components: {
                default: () =>
                    import(/* webpackChunkName: "user" */ './views/User.vue'),
            },
            children: [
                {
                    path: '',
                    name: 'profile',
                    component: () =>
                        import(
                            /* webpackChunkName: "profile" */
                            './components/UserProfile.vue'
                        ),
                },
            ],
        },
        {
            path: '/session/:_id([a-fA-F0-9]{24})',
            name: 'session-detail',
            props: { default: true },
            components: {
                default: () =>
                    import(
                        /* webpackChunkName: "session-detail" */
                        './views/SessionDetail.vue'
                    ),
            },
        },
        {
            path: '/community/:communityId([a-fA-F0-9]{24})',
            meta: { layout: 'Community' },
            props: (route) => ({ embed: route.query.embed }),
            components: {
                default: () =>
                    import(
                        /* webpackChunkName: "community" */ './views/Community.vue'
                    ),
            },
            children: [
                {
                    path: '',
                    name: 'community',
                    meta: { layout: 'Community' },
                    components: {
                        default: () =>
                            import(
                                /* webpackChunkName: "feed" */
                                './components/CommunityFeed.vue'
                            ),
                    },
                },
                {
                    path: 'participants',
                    name: 'participants',
                    meta: { layout: 'Community' },
                    props: { default: true },
                    component: () =>
                        import(
                            /* webpackChunkName: "participants" */
                            './components/CommunityParticipants.vue'
                        ),
                },
                {
                    meta: { layout: 'Community' },
                    path: 'content',
                    components: {
                        default: () =>
                            import(
                                /* webpackChunkName: "content" */
                                './components/CommunityContent.vue'
                            ),
                    },
                    children: [
                        {
                            path: ':activityId([a-fA-F0-9]{24})',
                            name: 'activity',
                            meta: { layout: 'Community' },
                            component: () =>
                                import(
                                    /* webpackChunkName: "activityDetail" */
                                    './components/CommunityActivityDetail.vue'
                                ),
                        },
                    ],
                },
                {
                    meta: { layout: 'Community' },
                    path: 'folder',
                    components: {
                        default: () =>
                            import(
                                /* webpackChunkName: "content" */
                                './components/CommunityContent.vue'
                            ),
                    },
                    children: [
                        {
                            path: ':id([a-fA-F0-9]{24})',
                            name: 'folder',
                            meta: { layout: 'Community' },
                            component: () =>
                                import(
                                    /* webpackChunkName: "activityList" */
                                    './components/CommunityActivityList.vue'
                                ),
                        },
                    ],
                },
                {
                    path: 'circle',
                    meta: { layout: 'Community' },
                    component: () =>
                        import(
                            /* webpackChunkName: "content" */
                            './components/CommunityContent.vue'
                        ),
                    children: [
                        {
                            path: ':id([a-fA-F0-9]{24})',
                            name: 'circle',
                            meta: { layout: 'Community' },
                            props: { default: true },
                            component: () =>
                                import(
                                    /* webpackChunkName: "community-circle" */
                                    './components/CommunityCircle.vue'
                                ),
                        },
                    ],
                },
                {
                    path: 'calendar',
                    name: 'calendar',
                    meta: { layout: 'Community' },
                    props: { default: true },
                    component: () =>
                        import(
                            /* webpackChunkName: "calendar" */
                            './components/CommunityCalendar.vue'
                        ),
                },
            ],
        },
        {
            path: '/inspirations',
            name: 'inspirations',
            components: {
                default: () =>
                    import(
                        /* webpackChunkName: "inspirations" */ './views/Inspirations.vue'
                    ),
            },
        },
        {
            path: '/inspirations/new',
            name: 'inspiration_new',
            components: {
                default: () =>
                    import(
                        /* webpackChunkName: "inspiration_new" */ './views/New_inspiration.vue'
                    ),
            },
        },
        {
            path: '/inspirations/:inspirationId([a-fA-F0-9]{24})',
            name: 'inspiration_view',
            components: {
                default: () =>
                    import(
                        /* webpackChunkName: "inspiration" */ './views/View_inspiration.vue'
                    ),
            },
        },
        
    ],
});

router.beforeEach((to, from, next) => {
    // console.log('beforeEach')
    if (
        (!store.getters.isLoggedIn || store.getters.isAnonymous) &&
        to.name != 'login' &&
        to.name != 'home' &&
        to.name != 'login_microsoft'
    ) {
        // console.log('saving currentUri in first if', to.fullPath);
        localStorage.setItem('currentUri', to.fullPath);
    }
    Vue.prototype.$Progress.start();
    if (to.query.lb && to.name != 'login') {
        if (to.query.embed == "true") {
            store.commit('SET_RENDER_NAVBAR', false);
        }
        if (store.getters.isLoggedIn) {
            store.dispatch('logout');
        }
        // console.log('saving currentUri in second if', to);
        if (to.params.communityId) {
            // console.log("adding communityId to query")
            to.query.community = to.params.communityId;
        }
        localStorage.setItem('currentUri', to.path);
        return next({
            name: 'login',
            query: to.query,
        });
    }
    /*if (!store.getters.isLoggedIn && !to.query.lb) {
        store.dispatch('anonymousLogin');
    }*/
    if (to.matched.some((record) => record.meta.denyVicensUsers)) {
        if (localStorage.getItem('vicensUser')) {
            console.log("redirecting to my-communities")
            return next({
                name: 'my-comunities'
            });
        } else {
            next();
        }

    } else if (to.matched.some((record) => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!store.getters.isLoggedIn) {
            console.log('not logged in returning');
            next({
                path: '/',
            });
        } else {
            next();
        }
    } else if (to.matched.some((record) => record.meta.requiresAnonymous)) {
        // this route requires no auth, check if logged in
        return next();
        if (store.getters.isLoggedIn) {
            next({
                name: 'dashboard',
                query: {
                    filter: 'mine',
                },
            });
        } else {
            next();
        }
    } else {
        next(); // make sure to always call next()!
    }
});

router.afterEach(() => {
    Vue.prototype.$Progress.finish();
});

router.onError((error) => {
    if (/loading chunk \d* failed./i.test(error.message)) {
        console.warn('reloading because of chunk failed');
        window.location.reload();
    }
});

export default router;
